import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getConfig, testConfigValue, setConfigValue } from '../api/config.js';

export const useSystemConfig = () =>
  useQuery({ queryKey: ['system-config'], queryFn: getConfig, staleTime: 60_000 });

export const useTestConfigValue = () =>
  useMutation({ mutationFn: ({ key, value }) => testConfigValue(key, value) });

export const useSetConfigValue = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ key, value }) => setConfigValue(key, value),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['system-config'] }),
  });
};
